import { ONSITE_REGISTRATION, REGISTRATION_END_DATE } from "./constants";

const isRegistrationOpen = () => {
    return REGISTRATION_END_DATE > new Date() || new Date() > ONSITE_REGISTRATION;
};

export { isRegistrationOpen };